import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import LegalTeam from '../../../assets/images/components/LegalTeam';
import RobustAi from '../../../assets/images/components/RobustAi';
import LawVision from '../../../assets/images/components/LawVision';

const edgeCards = [
  {
    icon: <LegalTeam />,
    title: 'A strong legal team with deep domain knowledge and advisory insight',
  },
  {
    icon: <RobustAi />,
    title: 'A robust tech team building AI solutions tailored to legal realities',
  },
  {
    icon: <LawVision />,
    title: 'A shared vision to make law more efficient, accessible, and impactful',
  },
];

const OurEdge = () => {
  return (
    <section className="our-edge-section section-gap-lg">
      <Container>
        <div className="our-edge-wrapper">
          <div data-aos="fade-up">
            <h2 className="our-edge-title">
              Our <span className="highlight-text">Edge</span>
            </h2>
          </div>

          <Row className="our-edge-row">
            {edgeCards.map((card, index) => (
              <Col
                lg={4}
                key={index}
                className="our-edge-column"
                data-aos="fade-up"
                data-duration={index * 100}
              >
                <div className="our-edge-card">
                  <div className="our-edge-icon">{card.icon}</div>
                  <p className="our-edge-text">{card.title}</p>
                </div>
              </Col>
            ))}
          </Row>

          <p className="our-edge-description" data-aos="fade-up">
            At Legalligence, we're not just transforming how legal work gets done—we're reimagining
            what's possible when legal intelligence meets innovation.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default OurEdge;
